module.exports = __webpack_public_path__ + "static/img/装饰9.108c5b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰9.svg
// module id = SXkr
// module chunks = 2